import { useState } from "react";
import { inputCls } from "@/components/FormBits";
import { domainSuggestions, typoFix } from "@/data/emailDomains";

export const EmailInput = ({ value, onChange }) => {
  const [focus, setFocus] = useState(false);
  const list = focus ? domainSuggestions(value) : [];
  const fix = !focus && value.includes("@") ? typoFix(value) : null;
  return (
    <div className="relative">
      <input id="email" type="email" autoComplete="email" value={value} onChange={(e) => onChange(e.target.value.trim())}
        onFocus={() => setFocus(true)} onBlur={() => setTimeout(() => setFocus(false), 150)}
        data-testid="step2-email-input" className={inputCls} />
      {list.length > 0 && (
        <ul data-testid="email-domain-suggestions" className="absolute z-20 mt-1 w-full overflow-hidden rounded-2xl border border-navy/10 bg-white shadow-lg">
          {list.map((s) => (
            <li key={s}>
              <button type="button" onMouseDown={() => onChange(s)} data-testid={`email-suggestion-${s.split("@")[1]}`} className="w-full px-4 py-2.5 text-left text-sm text-navy hover:bg-ivory">{s}</button>
            </li>
          ))}
        </ul>
      )}
      {fix && (
        <p className="mt-2 text-xs text-navy/70" data-testid="email-typo-hint">
          Vouliez-vous dire{" "}
          <button type="button" onClick={() => onChange(fix)} data-testid="email-typo-fix-button" className="font-medium text-navy underline decoration-gold underline-offset-2">{fix}</button> ?
        </p>
      )}
    </div>
  );
};
